<button nbButton size="small" title="Export as CSV" (click)="onExportAsCSV()">
  <i class="ion-archive"></i>&nbsp; Export
</button>
